/* @flow weak */
import { List } from 'immutable'
import * as authActions from '../auth/actions'
import * as testsActions from '../tests/actions'
import * as lessonsActions from '../lessons/actions'
import * as actions from './actions'
import User from './User'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  viewer: null,
  registeringUser: null,
  signedOutUser: null,
  usersInvited: false,
  subscribers: [],
  meta: new ListMeta(),
  all: new List(),
  current: null,
  stats: null,
}, 'users')

const usersReducer = (state = new State(), action) => {
  switch (action.type) {
    case authActions.SIGN_OUT: {
      const currentUser = state.get('viewer')

      let signedOutUser = state.get('signedOutUser')

      if (currentUser) {
        signedOutUser = {
          id: currentUser.id,
          role: currentUser.role,
        }
      }

      return state.set('viewer', null)
                  .set('signedOutUser', signedOutUser)
    }
    case actions.TEST_SIGN_UP_SUCCESS: {
      const newUser = action.payload.data
      console.log('newUser: ', newUser)
      if (newUser.name && newUser.tokens) {
        return state.set('viewer', newUser)
      }
      return state.set('registeringUser', newUser)
    }
    case actions.SIGN_UP_SUCCESS:
    case authActions.SOCIAL_AUTH_FACEBOOK_SUCCESS:
    case authActions.SOCIAL_AUTH_GOOGLE_SUCCESS:
    case authActions.SIGN_IN_SUCCESS: {
      const user = new User(action.payload.data)
      return state.set('viewer', user)
                  .set('registeringUser', null)
    }
    case authActions.RESET_PASSWORD_SUCCESS: {
      return state
    }
    case actions.FOLLOW_USER_SUCCESS: {
      const user = state.get('viewer')
      return state.setIn(['viewer', 'following'], [...user.following, action.payload.data])
    }
    case actions.USERS_LOAD_SUCCESS: {
      const users = List(action.payload.data.map(json => new User(json)))
      return state.set('all', users)
    }
    case actions.USER_LOAD_SUCCESS: {
      const data = action.payload.data
      let user = null
      if (data) {
        user = new User(data)
      }
      return state.set('current', user)
    }
    case actions.USER_UPDATE_SUCCESS: {
      const user = new User(action.payload.data)
      return state.set('current', user)
    }
    case actions.USER_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case testsActions.TEST_SAVE_SUCCESS:
    case authActions.CHANGE_PASSWORD_SUCCESS:
    case actions.USERS_UPDATE_ME_SUCCESS: {
      const viewer = state.get('viewer').toJS()
      const json = action.payload.data
      const newViewerData = Object.assign({}, viewer, json)
      return state.set('viewer', new User(newViewerData))
    }
    case actions.FORGOTTEN_PASSWORD_SUCCESS: {
      return state.set('current', true)
    }
    case actions.SET_USER_INFO: {
      return state.set('registeringUser', { ...action.payload })
    }
    case actions.SET_NAME: {
      return state.set('current', new User({ name: action.payload }))
    }
    case actions.USER_CLEAR: {
      return state.set('current', null)
    }
    case actions.USERS_CLEAR: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.STATS_LOAD_SUCCESS: {
      return state.set('stats', action.payload.data)
    }
    case actions.STATS_CLEAR: {
      return state.set('stats', null)
    }
    case actions.SUBSCRIBERS_LOAD_SUCCESS: {
      const data = action.payload.data
      return state.set('subscribers', data)
    }
    case lessonsActions.LESSON_ADD_SUCCESS: {
      const user = state.get('viewer')
      if (!user) {
        /* Lesson created during onboarding */
        return state
      }
      const userObj = user.toJS()
      userObj.userLessons = [...userObj.userLessons, action.payload.data]
      return state.set('viewer', new User(userObj))
    }
    case lessonsActions.LESSON_EDIT_SUCCESS: {
      const user = state.get('viewer').toJS()
      const lesson = action.payload.data
      if (!user.userLessons.find(l => l._id === lesson._id)) {
        user.userLessons = [...user.userLessons, lesson]
      }
      return state.set('viewer', new User(user))
    }
    case lessonsActions.LESSON_ADD_FAVORITE_SUCCESS: {
      const userObj = state.get('viewer')
      const user = userObj && userObj.toJS()
      if (user) {
        user.favoriteLessons = [...user.favoriteLessons, action.payload.data.id]
        return state.set('viewer', new User(user))
      }
      return state
    }
    case lessonsActions.LESSON_DELETE_SUCCESS: {
      const userObj = state.get('viewer')
      const user = userObj && userObj.toJS()
      if (user) {
        const deletedID = action.payload.data._id
        user.userLessons = user.userLessons.filter(lesson =>
          (lesson !== deletedID && lesson._id !== deletedID))
        return state.set('viewer', new User(user))
      }
      return state
    }
    default:
      return state
  }
}

export default usersReducer



// WEBPACK FOOTER //
// ./src/common/users/reducer.js